import { type AssetTypeFields, type Stored } from "@overmap-ai/common"
import { selectAttachmentsOfAssetTypeFields } from "@overmap-ai/core"
import { FieldsRenderer } from "@overmap-ai/forms"
import { cx } from "class-variance-authority"
import { type ComponentProps, memo } from "react"

import { sdk } from "../../sdk"
import { useShallowEqaulSelector } from "../../store"
import { draftCancelButtonProps, submitButtonProps } from "./constants"
import { useDeserializeFieldSchemaConfig, useFieldSchemaFromConfig, useHydrateFieldsWithAttachments } from "./hooks"

interface AssetTypeFieldsSubmitterProps extends Omit<
	ComponentProps<typeof FieldsRenderer>,
	"fieldSchema" | "submitButtonProps" | "cancelButtonProps"
> {
	assetTypeFields: Stored<AssetTypeFields>
}

export const AssetTypeFieldsSubmitter = memo<AssetTypeFieldsSubmitterProps>((props) => {
	const { className, assetTypeFields, ...rest } = props

	const attachments = useShallowEqaulSelector(selectAttachmentsOfAssetTypeFields(assetTypeFields.uuid))

	const fieldSchemaConfig = useDeserializeFieldSchemaConfig(assetTypeFields.fields)

	const fieldsWithImages = useHydrateFieldsWithAttachments(
		fieldSchemaConfig,
		attachments,
		sdk.assetTypeFieldsAttachments,
	)
	const fieldSchema = useFieldSchemaFromConfig(fieldsWithImages)

	return (
		<FieldsRenderer
			className={cx(className, "h-max w-full")}
			fieldSchema={fieldSchema}
			submitButtonProps={submitButtonProps}
			cancelButtonProps={draftCancelButtonProps}
			{...rest}
		/>
	)
})

AssetTypeFieldsSubmitter.displayName = "FormSubmitter"
